import { SortOrder } from 'antd/es/table/interface'
import dayjs from 'dayjs'
export const filterOption = (
  inputValue: string,
  option?: { label?: string },
) => {
  if (!option?.label) return false
  return (
    option.label.toLowerCase().includes(inputValue.trim().toLowerCase()) ??
    false
  )
}

export const normalizeDate = (date: string | Date) =>
  dayjs(date).format('YYYY-MM-DD')

export const normalizeObject = (obj: Record<string, any>) => {
  if (Object.keys(obj).length === 0) return
  const arrayFields = ['walletIds', 'currencies']

  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => Boolean(value)),
  )
}

export const get_sorter = (
  field?: string,
): { order: SortOrder; field: string } | undefined => {
  if (!field) return
  if (field.startsWith('-')) {
    return { order: 'descend', field: field.slice(1) }
  }
  return { order: 'ascend', field }
}
